<template>
</template>

<script>
  import {  watchEffect } from "vue";
  import { f7 } from 'framework7-vue'; 
  import { useTimer } from 'vue-timer-hook';

  export default {
    name: 'timeout',
    data() {
      return {
        unwatch: null,
        timer: null,
        seconds: 600,
        show_reminder: true,
      };
    },
    mounted() {
      const self=this;
      const time=new Date();
      time.setSeconds(time.getSeconds() + self.seconds);
      self.timer=useTimer(time);
      self.unwatch=watchEffect(async ()=> {
        if(self.timer) {
          if(self.timer.isExpired) {
            self.unwatch();
            /* this is the last notification - don't do it
             * self.showNotificationIdle();
             */
            self.notificationIdle=null;
            f7.views.main.router.navigate('/expired');
          } else {
            var remaining=self.timer.minutes*60+self.timer.seconds;
            if(remaining<=.2*self.seconds && self.show_reminder) {
              self.show_reminder=false;
              self.showNotificationReminder();
            }
          }
        }
      });
      f7.on('touchstart:passive', function(event) {
        self.restart_timer();
      });
      f7.on('touchmove:passive', function(event) {
        self.restart_timer();
      });
    },
    watch: {
      timer: function(newTimer, oldTimer) {
        const self=this;
        if(self.timer.isExpired.value) {
          console.warn('IsExpired');
        }
      },
    },
    methods: {
      // Timeout
      restart_timer() {
        const self=this;
        self.show_reminder=true;
        const time=new Date();
        time.setSeconds(time.getSeconds() + self.seconds);
        self.timer.restart(time);
      },
      // NOTIFICATIONS
      showNotificationIdle() {
        const self=this;
        if(!self.notificationIdle) {
          const now=new Date();
          f7.popup.close();
          self.notificationIdle=f7.notification.create({
            icon: '<i class="icon demo-icon">;(</i>',
            title: 'Sesiunea a expirat',
            titleRightText: now.toLocaleString('ro-RO', {hour: 'numeric', minute: 'numeric', second: 'numeric'}),
            subtitle: 'sesiunea a fost terminată datorită lipsei de activitate',
            text: 'apasa aici pentru a inchide',
            closeOnClick: true,
            on: {
              open: function() {
                localStorage.clear();
                localStorage.setItem('token', 'timeout-token');
                console.log("localStorage clean by timeout");
                f7.off('touchstart:passive');
                f7.off('touchmove:passive');
              },
              closed: function () {
                self.notificationIdle=null;
                console.log("navigate to /expired");
                f7.views.main.router.navigate('/expired');
                //window.location.href='/';
              },
            },
          });
          self.notificationIdle.open();
        }
      },
      showNotificationReminder() {
        const self=this;
        if(!self.notificationReminder) {
          self.notificationReminder=f7.notification.create({
            icon: '<i class="icon icon-f7">;|</i>',
            title: 'Sesiune inactivă',
            subtitle: 'în câteva momente această sesiune va fi terminată datorită lipsei de activitate',
            text: 'apasa oriunde in aplicatie pentru a evita deconectarea automata',
            closeTimeout: 5000,
          })
        };
        self.notificationReminder.open();
      },
      // PAGE EVENTS
      onPageBeforeRemove() {
        const self=this;
        if(self.popup) self.popup.destroy();
        if(sse) sse.disconnect();
      },
      onPageAfterOut() {
        f7.notification.close();
      },
      // END METHODS.
    },
  };  

</script>
